export const BADGE_SIZE = {
    sm: {
        size: 'xxs',
    },
    md: {
        size: 20,
        iconSize: 12,
    },
    lg: {
        size: 'xs',
    },
    xl: {
        size: 'xs',
    },
};
export const BUTTON_SIZE = {
    sm: 'sm',
    md: 'md',
    lg: 'lg',
    xl: 'lg',
};
export const ICON_COLOR = {
    DEFAULT: 'text-and-element-default',
    DISABLED: 'text-and-element-disabled',
};
export const ICON_SIZE = {
    sm: 16,
    md: 20,
    lg: 24,
    xl: 24,
};
export const VALIDATION_BADGE = {
    default: null,
    error: {
        badgeColor: 'text-and-element-danger',
        icon: 'alert-triangle',
        iconColor: 'text-and-element-alternate',
    },
    valid: {
        badgeColor: 'text-and-element-success',
        icon: 'checkmark',
        iconColor: 'text-and-element-alternate',
    },
};
